module.exports = __webpack_public_path__ + "img/sunny.60e50f58.svg";